module.exports = __webpack_public_path__ + "static/media/locationbased.838eec1b.jpg";